import { Box, Card, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import Palette from '../../theme/palette'

const Overview = ({ data, isLoading }) => {
  return (
    <div>
      {isLoading ? (
        <Card style={{ display: 'flex', justifyContent: 'center', paddingBottom: "70px" }}>
          <span className="loader" />
        </Card>
      ) : (
        <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
          <Box p={3}>
            <Grid container display="flex" spacing={4}>
              <Grid item xs={12} sm={6}>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                  <Typography variant="body1">Source :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]}>{data?.source ? data?.source : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400], }} py={2}>
                  <Typography variant="body1">Error Message :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >{data?.message ? data?.message : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                  <Typography variant="body1">Created On :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >
                    {
                      data?.createdOn ? dayjs(data?.createdOn).format("DD/MM/YYYY") : "--"
                    }
                  </Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                    <Typography variant="body1"> Status :</Typography>
                    <Typography variant="body2" color={Palette.grey[600]}>{data?.status ? data?.status : "--"}</Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400], }} py={2}>
                  <Typography variant="body1">Resolved :</Typography>
                  <Typography variant="body2" color={Palette.common.white} backgroundColor={data?.resolved ? Palette.success.main : Palette.error.main} padding={1} borderRadius={4}>
                    {data?.resolved ? "Yes" : "No"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                  <Typography variant="body1">Data :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >
                    {
                      data?.data ? data?.data : "--"
                    }
                  </Typography>
                </Grid>
                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                  <Typography variant="body1">Full Error Details :</Typography>
                  <Typography variant="body2" color={Palette.grey[600]} >
                    {
                      data?.fullError ? data?.fullError : "--"
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Card>
      )}

    </div>
  )
}

export default Overview
